import Reveal from './Reveal';
import { settingsTips } from '../content';

export default function SettingsTips() {
  return (
    <section id="tips" className="scroll-mt-24 bg-[#F7F4EC] py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <p className="font-display text-xs tracking-[0.35em] text-emerald-700 uppercase">Settings · 设置技巧</p>
            <h2 className="mt-3 text-2xl font-bold tracking-tight text-stone-900 md:text-4xl">
              把这几个开关调好，体验立刻不一样
            </h2>
            <p className="mt-4 text-sm leading-7 text-stone-500 md:text-[15px]">
              吃瓜软件设置技巧其实很轻。跟着下面四组推荐项调整，通知不吵、眼睛舒服、隐私也更安心。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {settingsTips.map((tip, i) => (
            <Reveal key={tip.title} delay={i * 80}>
              <article className="flex h-full flex-col rounded-xl bg-white p-6 transition-colors hover:bg-emerald-50/60">
                <div className="flex items-start justify-between">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
                    <i className={`${tip.icon} text-xl`}></i>
                  </span>
                  <span className="rounded-full bg-rose-100 px-2 py-0.5 text-[11px] font-medium text-rose-600">{tip.tag}</span>
                </div>
                <h3 className="mt-4 text-base font-semibold text-stone-900">{tip.title}</h3>
                <p className="mt-2 text-sm leading-6 text-stone-500">{tip.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}